var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.state)?_c('div',{staticClass:"AlgoliaEventsDateFilter"},[_c('BaseIcon',{staticClass:"AlgoliaEventsDateFilter__icon-calendar text--blue",attrs:{"icon":"date-picker-icon"}}),_vm._v(" "),_c('DatePicker',{attrs:{"placeholder":"Dates","init-options":{
            dateFormat: 'U',
            maxDate: _vm.state.range.max.toString(),
            minDate: _vm.state.range.min.toString(),
            mode: 'range',
            ..._vm.defaultDate
        }},on:{"change":_vm.refineDate,"mounted":_vm.handleMounted}}),_vm._v(" "),_c('BaseIcon',{staticClass:"AlgoliaEventsDateFilter__icon-chevron text--blue",attrs:{"icon":"chevron-down-icon"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }